<div class="summernote-container" >
    @if(scriptsLoaded && config !== null) {
        @defer (on immediate) {
            
            <div
                #editor
                [ngxSummernote]="config"
                [ngxSummernoteDisabled]="disabled"></div>
                
            
        } @placeholder {
            <div class="summernote-placeholder-div" [style.height]="styleHeight" [style.display]="'block'">
                <img [src]="placeholderImageDataUrl" alt="Editor loading..." />
            </div>
        } @loading (minimum 50ms){
            <div class="summernote-placeholder-div" [style.height]="styleHeight" [style.display]="'block'">
                <img [src]="placeholderImageDataUrl" alt="Editor loading..." />
            </div>
        } @error {
            <div>
                Error Loading Component
            </div>
        }
    } @else {
        <div class="summernote-placeholder-div" [style.height]="styleHeight" [style.display]="'block'" >
            <img [src]="placeholderImageDataUrl" alt="Editor loading..." />
        </div>
    }

    @if (auth.hasAll('RIGHT_CS_SYS_HELP_READ_DOCUMENTATION') && showDocumentationLink) {
        <!-- Wegen float right in der documentationLink class aus his-documentaton-link reproduziert-->
        <a hisImage="LINK_EXTERN" class="documentationLink" style="float:none;" target="_blank"
        href="../../pages/cs/sys/portal/documentation/documentation.faces?navigationPosition=documentation&amp;site={{documentationUrl}}"
        title="{{'Dokumentation: Grundlagen, Bedienung, erste Schritte-HISinOne' }}">{{'de.his.portal.doku'
            | hisUi}}: Arbeiten mit dem Richtext-Editor</a>
    
    }
</div>